import React from 'react'
import Box from '@mui/material/Box'
import StarIcon from '@mui/icons-material/Star'
import Typography from '@mui/material/Typography'

interface Props {
  color?: string
}

const ReportFavoriteLabel: React.FC<Props> = ({ color = '#72828E' }) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      sx={{ color: color, fontSize: '0.9rem' }}
    >
      <StarIcon fontSize="inherit" color="inherit" />
      <Typography
        pl={0.5}
        component="small"
        sx={{ color: color, fontSize: '0.9rem' }}
      >
        Bookmarks
      </Typography>
    </Box>
  )
}

export default ReportFavoriteLabel
